import { WINDOW } from '@abb-procure/constants';
import { DestroyRef, inject, Injectable, NgZone } from '@angular/core';
import { CanBlockNavigation } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class RouteNavigationService {
  private listeners: Set<CanBlockNavigation> = new Set();
  private readonly window = inject(WINDOW);
  private zone = inject(NgZone);

  constructor() {
    this.handleBeforeUnloadEvent = this.handleBeforeUnloadEvent.bind(this);

    this.zone.runOutsideAngular((): void => {
      this.window.addEventListener(
        'beforeunload',
        this.handleBeforeUnloadEvent,
      );
    });

    inject(DestroyRef).onDestroy(() => {
      this.window.removeEventListener(
        'beforeunload',
        this.handleBeforeUnloadEvent,
      );

      this.listeners.clear();
    });
  }

  /**
   * Registers a component which should be checked before a route navigation.
   */
  register(listener: CanBlockNavigation): void {
    this.listeners.add(listener);
  }

  /**
   * Unregisters a component from a route navigation checks.
   */
  unregister(listener: CanBlockNavigation): void {
    this.listeners.delete(listener);
  }

  private handleBeforeUnloadEvent(event: BeforeUnloadEvent): void {
    if (!this.canUnload()) {
      event.preventDefault();
    }
  }

  private canUnload(): boolean {
    for (const listener of this.listeners) {
      const result = this.zone.runGuarded(() => listener.canUnload());

      if (!result) {
        return false;
      }
    }

    return true;
  }
}
